import { render } from "./prestationPopup.vue?vue&type=template&id=4803ce4e&scoped=true"
import script from "./prestationPopup.vue?vue&type=script&lang=js"
export * from "./prestationPopup.vue?vue&type=script&lang=js"

import "./prestationPopup.vue?vue&type=style&index=0&id=4803ce4e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4803ce4e"]])

export default __exports__